import type { DatadogInitModel } from '@cw-elements/analytics-provider';
import { getDatadogInstance } from '@cw-elements/analytics-provider';
import { reactPlugin } from '@datadog/browser-rum-react';

function getDatadogRumParameters(): DatadogInitModel {
  return {
    applicationId: import.meta.env.VITE_APP_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: 'cropwise-imagery',
    env: import.meta.env.VITE_APP_ENV,
    version: import.meta.env.VITE_APP_VERSION || 'unknown',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    compressIntakeRequests: true,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: true })],
  };
}

function getDatadogLogsParameters() {
  return {
    clientToken: import.meta.env.VITE_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu' as const,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  };
}

/**
 * Standard cross-app RUM tags (M.04). `service` is set at init time above; `team` and `app_name`
 * are deployment-level and set here once RUM is initialized. `region` is user-specific in this
 * single global deployment, so it is set from the user's country in the analytics identity hook.
 */
function setDatadogGlobalContext() {
  getDatadogInstance()?.setGlobalContext({
    team: 'cropwise-imagery',
    app_name: 'cropwise-imagery',
  });
}

export { getDatadogLogsParameters, getDatadogRumParameters, setDatadogGlobalContext };
